import { createSelector } from '@ngrx/store';
import * as systemEventsReducer from './system-events.reducer';
import { SYSTEM_EVENTS_FEATURE_KEY } from './system-events.reducer';

/**
 * Reducer state selector
 */
export const getState = (state: {
    [SYSTEM_EVENTS_FEATURE_KEY]: systemEventsReducer.State;
}): systemEventsReducer.State => state[SYSTEM_EVENTS_FEATURE_KEY];

export const getLatestEvent = createSelector(
    getState,
    (state: systemEventsReducer.State) =>
        state?.events?.length
            ? state.events[state.events.length - 1]
            : undefined,
);

export const getLatestSignalrEvent = createSelector(
    getState,
    (state: systemEventsReducer.State) =>
        state?.signalrEvents?.length
            ? state.signalrEvents[state.signalrEvents.length - 1]
            : undefined,
);

export const getSignalrEvents = createSelector(
    getState,
    (state: systemEventsReducer.State) => state?.signalrEvents || [],
);
